import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFeatures, modifyFeature } from "@api/featureLibraryAPI";
import { log, getStackTrace } from "@src/Log.init";

export const retrieveFeatureLibrary = createAsyncThunk(
  "featureLibrary/retrieveFeatureLibrary",
  async (clientId, { getState, dispatch }) => {
    const response = await getFeatures(getState().session.sessionToken, clientId);
    await dispatch(setFeatures(response));
    return response;
  }
);

export const updateFeatureLibrary = createAsyncThunk(
  "featureLibrary/updateFeatureLibrary",
  async (body, { getState, dispatch }) => {
    const response = await modifyFeature(getState().session.sessionToken, body);
    dispatch(updateFeature(body));
  }
);

export const featureLibrarySlice = createSlice({
  name: "featureLibrary",
  initialState: {
    features: [],
  },
  reducers: {
    setFeatures: (state, action) => {
      return { ...state, features: [...action.payload] };
    },
    updateFeature: (state, action) => {
      const index = state.features.findIndex((obj) => {
        return obj.key === action.payload.key;
      });
      return {
        ...state,
        features: state.features.map((feature, i) =>
          i === index
            ? { ...feature, enabled: action.payload.enabled }
            : feature
        ),
      };
    },
  },
  extraReducers: {
    [retrieveFeatureLibrary.pending]: (state, action) => {
      log.debug({
        message_type: "User",
        message: "retrieving feature library...",
      });
    },
    [retrieveFeatureLibrary.fulfilled]: (state, action) => {
      log.info({
        message_type: "User",
        message: "feature library successful retrieve",
      });
    },
    [retrieveFeatureLibrary.rejected]: (state, action) => {
      log.error({
        message_type: "SystemError",
        message: "retrieving feature library failed...",
        meta_data: getStackTrace(),
      });
    },
    [updateFeatureLibrary.pending]: (state, action) => {
      log.debug({
        message_type: "User",
        message: "updating feature library...",
      });
    },
    [updateFeatureLibrary.fulfilled]: (state, action) => {
      log.info({
        message_type: "User",
        message: "feature library successfully updated",
      });
    },
    [updateFeatureLibrary.rejected]: (state, action) => {
      log.error({
        message_type: "SystemError",
        message: "updating feature library failed...",
        meta_data: getStackTrace(),
      });
    },
  },
});

export const { setFeatures, updateFeature } = featureLibrarySlice.actions;
export const selectFeatureLibrary = (state) => state.featureLibrary.features;

export default featureLibrarySlice.reducer;
